export default __webpack_public_path__ + "static/media/YAS0220.34I-22781_-15214_0.cd3bf39f.jpg";